export function getFileName(url: string) {
  let fileName = url.split("/").pop();
  if (fileName) {
    fileName = fileName.split(".").slice(0, -1).join(".");
    return decodeURIComponent(fileName);
  }
  return url;
}
